/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Horizontal_Padding_HelpInputs */



/**
* | output |
* | --- |
* | "Left/right screen padding (0-50%)" |
*
* @param {Options_Display_Horizontal_Padding_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_horizontal_padding_help = /** @type {((inputs?: Options_Display_Horizontal_Padding_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Horizontal_Padding_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marge gauche/droite de l'écran (0-50%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linker/rechter Bildschirmabstand (0-50%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spaziatura schermo sinistra/destra (0-50%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отступы слева/справа на экране (0-50%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno de pantalla izquierda/derecha (0-50%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕左右边距（0-50%）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面の左/右の余白（0～50%）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन के बाएँ/दाएँ भाग में पैडिंग (0-50%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preenchimento lateral da tela (0-50%)")
	return /** @type {LocalizedString} */ ("Left/right screen padding (0-50%)")
});